import React from "react";
import { CalendarIcon } from "@heroicons/react/24/outline";
import { convertToBrazilDate } from "../../../helpers/date";
import { PostContentText } from "./PostContentText";
import { TagList } from "./TagList";

const PostDate = ({ date }) => (
  <div className="flex items-center gap-1 text-gray-400">
    <CalendarIcon className="size-4" />
    <span className="text-sm font-medium">{convertToBrazilDate(date)}</span>
  </div>
);

const PostItem = ({ id, title, content, published_at, tags }) => (
  <a href={`/blog/post/${id}`} id={`post-${id}`} className="block group">
    <article className="h-full rounded-lg bg-deep-space p-4 border-2 border-gray-700 transition-all duration-300 group-hover:border-brandpink">
      <h3 className="h-[58px] font-medium text-lg text-white mb-3 line-clamp-2 transition-colors duration-300 group-hover:text-brandpink">
        {title}
      </h3>

      <div className="text-gray-400 text-sm mb-3">
        <PostContentText
          content={content}
          className="overflow-hidden overflow-ellipsis bg-deep-space text-white line-clamp-2 transition-colors duration-300"
        />
      </div>

      <div className="flex flex-col gap-1">
        <PostDate date={published_at} />
        <TagList tags={tags} compact iconPosition="left" />
      </div>
    </article>
  </a>
);

export function AllPosts({ posts }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      {posts?.map((post) => (
        <PostItem key={post.id} {...post} />
      ))}
    </div>
  );
}
